import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function updateAgentAssistant(
  agentAssistantId,
  firstName,
  lastName,
  mobile,
  emailId,
  postalCode,
  viewCommissions
) {
  let options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      AgentAssistantId: agentAssistantId,
      FirstName: firstName,
      LastName: lastName,
      Mobile: mobile,
      EmailId: emailId,
      PostalCode: postalCode,
      ViewCommissions: viewCommissions,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/agentassistant",
    options
  );
  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
